import React from 'react';
import { Header } from './components/Header';
import { Hero } from './components/Hero';
import { ProofStrip } from './components/ProofStrip';
import { Positioning } from './components/Positioning';
import { Problem } from './components/Problem';
import { MarketGap } from './components/MarketGap';
import { History } from './components/History';
import { Product } from './components/Product';
import { CorePromise } from './components/CorePromise';
import { Workflow } from './components/Workflow';
import { FirstReport } from './components/FirstReport';
import { AttackPathExamples } from './components/AttackPathExamples';
import { AISecurityValidation } from './components/AISecurityValidation';
import { Verification } from './components/Verification';
import { Evidence } from './components/Evidence';
import { Missions } from './components/Missions';
import { Integrations } from './components/Integrations';
import { Audiences } from './components/Audiences';
import { Pricing } from './components/Pricing';
import { Competitive } from './components/Competitive';
import { Safety } from './components/Safety';
import { EarlyAccess } from './components/EarlyAccess';
import { About } from './components/About';
import { JoinTeam } from './components/JoinTeam';
import { FAQ } from './components/FAQ';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
import { SectionStage } from './components/SectionStage';
export function App() {
  return <div className="relative w-full bg-[#050608] text-white selection:bg-[#1a8fd4]/30" data-id="element-0">
      {/* SVG filter defs (legacy logo support) */}
      <svg width="0" height="0" className="absolute" aria-hidden="true" data-id="element-1">
        <defs data-id="element-2">
          <filter id="periscan-remove-white" colorInterpolationFilters="sRGB" data-id="element-3">
            <feColorMatrix type="matrix" values="-1 0 0 0 1
                       0 -1 0 0 1
                       0 0 -1 0 1
                       0 0 0 1 0" data-id="element-4" />
            <feColorMatrix type="hueRotate" values="180" data-id="element-5" />
            <feColorMatrix type="matrix" values="1 0 0 0 0
                      0 1 0 0 0
                      0 0 1 0 0
                      1 1 1 0 0" data-id="element-6" />
          </filter>
        </defs>
      </svg>

      <Header data-id="element-7" />

      <main id="top" className="pt-9" data-id="element-8">
        <Hero data-id="element-9" />

        <SectionStage intensity={0.4} fx="beams" data-id="element-10">
          <ProofStrip data-id="element-11" />
        </SectionStage>

        <SectionStage intensity={1} fx="particles" data-id="element-12">
          <Positioning data-id="element-13" />
        </SectionStage>

        <SectionStage intensity={1} fx="lightning" data-id="element-14">
          <Problem data-id="element-15" />
        </SectionStage>

        <SectionStage intensity={1} fx="squares" data-id="element-16">
          <MarketGap data-id="element-17" />
        </SectionStage>

        <SectionStage intensity={1} fx="threads" data-id="element-18">
          <History data-id="element-19" />
        </SectionStage>

        <SectionStage intensity={1} fx="orbit-right" data-id="element-20">
          <Product data-id="element-21" />
        </SectionStage>

        <SectionStage intensity={1} fx="aurora" data-id="element-22">
          <CorePromise data-id="element-23" />
        </SectionStage>

        <SectionStage intensity={1} fx="orbit-left" data-id="element-24">
          <Workflow data-id="element-25" />
        </SectionStage>

        <SectionStage intensity={1} fx="aurora-particles" data-id="element-26">
          <FirstReport data-id="element-27" />
        </SectionStage>

        <SectionStage intensity={1} fx="lightning" data-id="element-28">
          <AttackPathExamples data-id="element-29" />
        </SectionStage>

        <SectionStage intensity={1} fx="orbit" data-id="element-30">
          <AISecurityValidation data-id="element-31" />
        </SectionStage>

        <SectionStage intensity={1} fx="beams" data-id="element-32">
          <Verification data-id="element-33" />
        </SectionStage>

        <SectionStage intensity={1} fx="particles" data-id="element-34">
          <Evidence data-id="element-35" />
        </SectionStage>

        <SectionStage intensity={1} fx="squares" data-id="element-36">
          <Missions data-id="element-37" />
        </SectionStage>

        <SectionStage intensity={1} fx="threads" data-id="element-38">
          <Integrations data-id="element-39" />
        </SectionStage>

        <SectionStage intensity={1} fx="orbit-right" data-id="element-40">
          <Audiences data-id="element-41" />
        </SectionStage>

        <SectionStage intensity={1} fx="beams-squares" data-id="element-42">
          <Pricing data-id="element-43" />
        </SectionStage>

        <SectionStage intensity={1} fx="waves" data-id="element-44">
          <Competitive data-id="element-45" />
        </SectionStage>

        <SectionStage intensity={1} fx="aurora" data-id="element-46">
          <Safety data-id="element-47" />
        </SectionStage>

        <SectionStage intensity={0.5} fx="particles" data-id="element-48">
          <EarlyAccess data-id="element-49" />
        </SectionStage>

        <SectionStage intensity={1} fx="threads" data-id="element-50">
          <About data-id="element-51" />
        </SectionStage>

        <SectionStage intensity={1} fx="orbit-left" data-id="element-52">
          <JoinTeam data-id="element-53" />
        </SectionStage>

        <SectionStage intensity={1} fx="particles" data-id="element-54">
          <FAQ data-id="element-55" />
        </SectionStage>

        <SectionStage intensity={1} fx="aurora-particles" data-id="element-56">
          <FinalCTA data-id="element-57" />
        </SectionStage>
      </main>

      <Footer data-id="element-58" />
    </div>;
}